import { Spinner } from "react-bootstrap";
import styled, { keyframes } from "styled-components";

const ellipsis = keyframes`
  to {
    width:1.25em;
  }`;

const EllipsisWrapper = styled.div`
  display: inline-block;
  min-width: 1.875rem;
  text-align: left;
  vertical-align: bottom;
`;
const Ellipsis = styled.div`
  overflow: hidden;
  -webkit-animation: ${ellipsis} steps(4, end) 2000ms infinite;
  animation: ${ellipsis} steps(4, end) 2000ms infinite;
  width: 0px;
`;

export const Loading = () => {
  return (
    <div id="loadingScreen">
      <Spinner
        animation="border"
        variant="primary"
        style={{ width: 75, height: 75 }}
      >
        <span className="sr-only">Loading...</span>
      </Spinner>
      <h1>
        Loading
        <EllipsisWrapper>
          <Ellipsis>...</Ellipsis>
        </EllipsisWrapper>
      </h1>
    </div>
  );
};
